/**
 * Single nav destination row, 40px, radius 6. Extends the row styling
 * already shipped for the main nav (PageTemplate/SidebarNav.module.scss,
 * design_handoff_sidebar_nav) with the collapsed icon-only + tooltip state
 * the app-shell handoff adds on top.
 * Spec: assets/handoffs/design_handoff_app_shell (component table, Rules —
 * collapse).
 *
 * @param {string} label
 * @param {string} icon - Icon name from theme/untitled/icons
 * @param {string=} to - internal route; renders a react-router Link
 * @param {string=} href - external URL; renders an <a>
 * @param {function=} onClick
 * @param {boolean=false} active
 * @param {boolean=false} collapsed - icon-only, wrapped in SidebarTooltip
 * @param {boolean=false} child - 36px row, no icon, indented (expanded only)
 */
import React from "react";
import { Link } from "react-router-dom";
import classNames from "classnames";
import Icon from "../../../theme/untitled/icons/Icon";
import SidebarTooltip from "../SidebarTooltip/SidebarTooltip";
import styles from "../../PageTemplate/SidebarNav.module.scss";

const SidebarNavItem = ({
  label,
  icon,
  to,
  href,
  onClick,
  active = false,
  collapsed = false,
  child = false,
}) => {
  const className = classNames(styles.row, {
    [styles["row--current"]]: active,
    [styles["row--collapsed"]]: collapsed,
    [styles["row--child"]]: child && !collapsed,
  });

  const content = (
    <>
      {!child && icon && <Icon name={icon} className={styles.icon} />}
      {!collapsed && <span className={styles.label}>{label}</span>}
    </>
  );

  const row = href ? (
    <a href={href} target="_blank" rel="noreferrer" className={className} onClick={onClick}>
      {content}
    </a>
  ) : (
    <Link to={to} className={className} onClick={onClick}>
      {content}
    </Link>
  );

  return collapsed ? <SidebarTooltip label={label}>{row}</SidebarTooltip> : row;
};

export default SidebarNavItem;
